import * as yup from 'yup'
import { LabelType } from 'types/Label'

const colorRegExp = /^#[0-9a-fA-F]{6}$/

const NameTranslationObject = yup.object().shape({
  languageCode: yup.string(),
  value: yup.string().required('labels.errors.name.required')
})

const CreateLabelSchema = yup.object().shape({
  name: yup.string().required('labels.errors.name.required'),
  nameTranslations: yup.array().of(NameTranslationObject),
  color: yup.string()
    .required('labels.errors.color.required')
    .matches(colorRegExp, 'labels.errors.color.invalid'),
  type: yup
    .string()
    .oneOf([
      LabelType.USER_DEFINED,
      LabelType.ADMIN_DEFINED
    ], 'labels.errors.type.incorrect')
    .required('labels.errors.type.required'),
})

const EditLabelSchema = CreateLabelSchema

export {
  CreateLabelSchema,
  EditLabelSchema
}
